import React from 'react';
import '../asstes/switchLangage.css';
const SwitchlLanguage = ({ onLngChange }) => {
    return (
        <div className="btn-group btn-margin navbar-toggler" role="group" aria-label="Basic example" data-bs-target="#navbarResponsive" id="navbarResponsive">
            <button type="button" className="btn btn-secondary-switch" onClick={() => onLngChange("An")}>Anglais</button>
            <button type="button" className="btn btn-secondary-switch" onClick={() => onLngChange("Fr")}>Français</button>
            <button type="button" className="btn btn-secondary-switch" onClick={() => alert("قريب سيكون متوفر ")}>Arabe</button>
        </div>
    );
};

export default SwitchlLanguage;